export default  [
    { value: 49000, name: '0 - 49 тыс. км' },
    { value: 99000, name: '50 - 99 тыс. км' },
    { value: 149000, name: '100 - 149 тыс. км' },
    { value: 199000, name: '150 - 199 тыс. км' },
    { value: 249000, name: '200 - 249 тыс. км' },
    { value: 299000, name: '250 - 299 тыс. км' },
    { value: 300000, name: 'Более 300 тыс. км' },
]
